export default __webpack_public_path__ + "static/media/lock.377a8c55.svg";